/**
 * Created by Carsten Bühler
 * User: CBuehler on 05.01.2016
 * Copyright: xdot GmbH 2015
 */

import { ActionTypesCommon, RemoteDataStore } from 'plugin/liferay-widgets-react-web';

import { getFeatureId } from '../utils/geo-utils';

export default class GeoJsonStore extends RemoteDataStore {

    constructor(dispatcher){
        super(dispatcher);
    }

    reduce(state, action){
        let name, className;

        switch (action.type) {
            case ActionTypesCommon.DATA_ITEM_INIT:
                ({ name, className } = action.meta);
                if ('GeoJson' === className) {
                    state = this.initItem(state, name, {
                        ...action.payload,
                        className
                    }, this.defaultItemData);
                    //   let data = RemoteDataStore.getData(state.remote, action.meta.name);
                    //   data = RemoteDataStore.updateQuery(data, { changedSince: new Date().getTime() });
                    //   return  this.doSetRemoteState(state, RemoteDataStore.setData(state.remote, data));
                }
                break;
            case ActionTypesCommon.DATA_REMOVE:
                ({ name, className } = action.meta);
                if ('GeoJson' === className) {
                    return this.removeRemoteData(state, name);
                }
                break;
            case ActionTypesCommon.DATA_UPDATE_MESSAGE:
                const remote = this.websocketModelUpdate(state.remote, action.payload);
                if (state.remote !== remote) {
                    state = this.doSetRemoteState(state, remote);
                }
                break;
        }

        if (action.meta && 'GeoJson' === action.meta.className) {
            //      action.meta.className = null;
            state = super.reduce(state, action);
        }

        return state;
    }

    asyncSuccess(data, newItem){
        if (newItem.properties.changedSince > 0) {
            newItem.features = this.updateFeature(data.item.features, newItem.features);
        }
        const newData = RemoteDataStore.updateItem(data, newItem);
        newData.query = {
            ...newData.query,
            changedSince: newItem.properties.queryTime
        };
        return newData;
    }

    updateFeature(oldFeatures, changedFeatures){
        let newFeatures = oldFeatures;
        if (changedFeatures && changedFeatures.length > 0) {
            const toAdd = [];
            const changedFeatureMap = changedFeatures.reduce((acc, feature) => {
                if (oldFeatures.findIndex(of => of.properties.id === feature.properties.id) < 0) {
                    toAdd.push(feature);
                } else {
                    acc[getFeatureId(feature)] = feature;
                }
                return acc;
            }, {});
            newFeatures = oldFeatures.map((of, i) => {
                const id = getFeatureId(of);
                return changedFeatureMap[id] || of;
            });
            newFeatures.push(...toAdd);
        }
        return newFeatures;
    }

    getDataClassNames(d){
        const classes = {};
        if (d.item && d.item.features) {
            d.item.features.forEach(feature => classes[feature.properties.type] = true);
        }
        if (d.query && d.query.classNames) {
            d.query.classNames.forEach(nc => classes[nc] = true);
        }
        return Object.keys(classes);
    }

    websocketModelUpdate(remote, wsUpdate){
        let newRemote;

        if (wsUpdate.eventType === 'POST' || wsUpdate.eventType === 'PUT' || wsUpdate.eventType === 'PATCH' || wsUpdate.eventType === 'PATCH-MERGE' || wsUpdate.eventType === 'DELETE' || wsUpdate.eventType === 'DELETE') {
            const { type: className } = wsUpdate;
            let attachedClassName;
            if (wsUpdate.metadata) {
                attachedClassName = wsUpdate.metadata.attachedClassName;
            }

            RemoteDataStore.remoteStatetoDataArray(remote).filter(d => {
                let cn = this.getDataClassNames(d);
                return cn.indexOf(className) >= 0 || cn.indexOf(attachedClassName) >= 0;
            }).forEach(d => {
                const o = d;
                d = RemoteDataStore.invalidateData(o);
                if (o !== d) {
                    newRemote = (newRemote || (newRemote = { ...remote }));
                    newRemote[o.name] = d;
                }
            });

        } else if (!Array.isArray(wsUpdate) && !wsUpdate.metric) {
            console.warn('Unknown update type: ', wsUpdate);
        }

        if (this.extendedWebsocketModelUpdate) {
            newRemote = this.extendedWebsocketModelUpdate(newRemote || remote, wsUpdate);
        }

        return newRemote || remote;
    }

    //wihtout backup
    static invalidateData(existing){
        if (existing._invalid) {
            return existing;
        }
        return {
            ...existing,
            _invalid: true
        };
    }

}






// WEBPACK FOOTER //
// ./js/stores/GeoJsonStore.js